import React, { useMemo, useState } from "react";
import { Truck } from "lucide-react";

import { Input } from "@/components/ui/input";

// Texto livre com sugestões: fornecedores já usados em despesas + os salvos
// neste navegador (mesma fonte da tela antiga).
export default function CampoFornecedor({ valor, onChange, fornecedores }) {
  const [aberto, setAberto] = useState(false);
  const sugestoes = useMemo(() => {
    const t = valor.trim().toLowerCase();
    if (!t) return [];
    const achados = fornecedores.filter((s) => s.toLowerCase().includes(t));
    return achados.some((s) => s.toLowerCase() === t) ? [] : achados.slice(0, 8);
  }, [valor, fornecedores]);
  return (
    <div className="relative">
      <Truck className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
      <Input value={valor} onChange={(e) => { onChange(e.target.value); setAberto(true); }} onFocus={() => setAberto(true)}
        onBlur={() => setTimeout(() => setAberto(false), 200)} placeholder="Digite ou selecione um fornecedor" className="pl-9"
        data-e2e="campo-fornecedor" />
      {aberto && sugestoes.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-popover border rounded-md shadow-lg max-h-48 overflow-y-auto">
          {sugestoes.map((s) => (
            <div key={s} className="px-3 py-2 hover:bg-muted cursor-pointer flex items-center gap-2"
              onMouseDown={() => { onChange(s); setAberto(false); }}>
              <Truck className="w-4 h-4 text-muted-foreground" /><span>{s}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
